import BattleActions from '../battle-data/battle-actions.js'
import {percentChance} from '../../helpers/numbers-helper.js'

/** Potentially replace inputted action with other action based on casterModel state */
export function getReplacedAction(actionModel, casterModel) {



    //Check that this action is safe from being replaced
    if (!actionModel.canBeReplaced) {
        /*
         Examples:
         - recovering from lag: "natural_recover-lag"
         //Item
         //death
         //"clean" status clearing type of moves
         //recovering-from-lag
         */
        return actionModel;
    }


    //Replacement possibilities
    if (casterModel.status === "lag" && !actionModel.isImmuneFromLag) {
        //Roll the dice using the caster's probability rating (higher number = more likely to lag out)
        if (percentChance( casterModel.getLaggingProbability() )) {
            return {
                id: "natural_lag", //always must provide an id with every BattleAction merge.
                ...BattleActions["natural_lag"]
                //technically for completeness, I think an actionMeta should be included here too. but naturals don't need that?
            };
        }
        //If we survived the probability, return the initial action as intended
        //Note: `get-rollout` will prepend a "Caster is lagging..." message to the rollout.
        return actionModel;
    }


    //Default to the original actionModel
    return actionModel;

}

//From b4:
/*
 if ([
 "natural-death-a",
 "attack-008-a-resolve", //promise resolve
 "attack-special-006-a", //"clean" status back to normal
 "natural-recover-lag",
 ].indexOf(originalActionId) > -1) {
 return originalActionId;
 }

 ...

 if (casterModel.status == "lag" && actionModel.type != "Item") {
 return "natural-lag-a";
 }

 */


// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-replaced-action.js